/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConsultationStatusDto } from '../../models/consultation-status-dto';

export interface ConsultationAdminControllerUpdateStatusV1$Params {
  id: string;
      body: ConsultationStatusDto
}

export function consultationAdminControllerUpdateStatusV1(http: HttpClient, rootUrl: string, params: ConsultationAdminControllerUpdateStatusV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, consultationAdminControllerUpdateStatusV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    })
  );
}

consultationAdminControllerUpdateStatusV1.PATH = '/api/v1/consultations/admin/{id}/status';
